import { useConfig } from "@/api/hooks/useConfig";
import { CardFilterView } from "@/components/v2/CardView/components/CardFilterView";
import { currencies } from "@/pages/configuration/payments";
import { useConfigService } from "@/pages/configuration/useConfigService";
import { UNIT_LABELS } from "@/pages/reporting_v2/constants";
import { ReportingPageContext } from "@/pages/reporting_v2/context";
import {
  REPORTING_TABLE_UNIT,
  REPORTING_VIEW_TYPES,
} from "@/pages/reporting_v2/types";

import { useContext, useMemo } from "react";

import { ReportingTableContext } from "../../context";

export const ReportingUnitFilter = () => {
  const { viewType } = useContext(ReportingPageContext);
  const { unit, setUnit } = useContext(ReportingTableContext);

  const { terminalConfig } = useConfigService();
  const { config: clientConfig } = useConfig();

  const unitOptions = useMemo(() => {
    const currency = terminalConfig?.currency || clientConfig?.currency;
    const currencySymbol = currencies.find((c) => c.value === currency)?.symbol;

    // Costs are configured per building, so they only apply in building view.
    return Object.values(REPORTING_TABLE_UNIT)
      .filter(
        (key) =>
          key !== REPORTING_TABLE_UNIT.COST ||
          viewType !== REPORTING_VIEW_TYPES.PORTFOLIO,
      )
      .map((key) => ({
        key,
        label:
          key === REPORTING_TABLE_UNIT.COST && currencySymbol
            ? currencySymbol
            : UNIT_LABELS[key],
      }));
  }, [terminalConfig?.currency, clientConfig?.currency, viewType]);

  const unitFilter = useMemo(
    () => ({
      options: unitOptions,
      value: unit,
      onChange: (key: string) => setUnit(key as REPORTING_TABLE_UNIT),
      largeView: true,
    }),
    [unitOptions, unit, setUnit],
  );

  return <CardFilterView filter={unitFilter} />;
};
